import styles from '../PublishSent/index.less';
import { Button, Form, FormInstance, Input, Picker, Selector, Toast } from 'react-vant';
import SelectHouseTag from '@/pages/ServicesMore/HouseRentAndSale/components/SelectHouseTag';
import { useSafeState } from 'ahooks';
// import StickyActiveButton from '@/components/StickyActiveButton';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useModel } from '@umijs/max';
import { addWechatRent, getWechatRentDetail, updateWechatRent } from '@/service/rentHouse';

const PublishWantSale = () => {
  const [form] = Form.useForm();
  const [tagData, setTagData] = useState({})
  const [defaultTagData, setDefaultTagData] = useState({})
  const [detailData, setDetailData] = useState({
    sequenceNbr: ''
  })
  const { defaultRoom, ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      queryInformation: model.queryInformation,
      defaultRoom: model.defaultRoom,
      ownerInformation: model.ownerInformation
    }),
  );

  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');
 
  const formRef = useRef<FormInstance>(null);

  
  useEffect( () => {
    if (location && data) {
      const fetchData = async () => {
        try {
          await getWechatRentDetail(data).then(res => {
            if (res && res.code === 200) {
              const data = res.data;
              setDetailData(res.data)
              data.rentType = data.rentType ? [data.rentType] : []
              
              if (data.type === '3') {
                data.publishType = '求租'
              } else if (data.type === '4') {
                data.publishType = '求购'
              } else {
                data.publishType = ''
              }
             
              data.urlPath = data.urlPath ? data.urlPath.split(',') : []

              formRef.current?.setFieldsValue(data)

              const defaultTag = {
                roomType: data.roomType ? [data.roomType] : [],
                facing: data.facing ? [data.facing] : [],
                decoration: data.decoration ? [data.decoration] : [],
                layout: data.layout ? [data.layout] : [],
                floor: data.floor ? [data.floor] : [],
              }

              console.log(8888888, defaultTag)
              setDefaultTagData(defaultTag)
              onSuccess(defaultTag)
             
            }
          })
        } catch (error) {
          console.error('获取数据失败:', error);
        } finally {
      };
    }
      fetchData()
    }
  }, [])
  const [selectTagVisible, setSelectTagVisible] = useSafeState<boolean>(false);

  const communityPickerData = [{
    text: defaultRoom?.communityName,
    value: defaultRoom?.communityId,
  }];
  console.log('communityPickerData', communityPickerData)

 
  const onFinish = (values: any) => {
    console.log(values)
    if (Object.keys(tagData).length === 0) {
      Toast('请选择标签信息！')
      return
    }
    const params = {...values, ...tagData}
    if (params.publishType === '求租') {
      params.type = '3'
    }

    if (params.publishType === '求购') {
      params.type = '4'
    }
    params.rentType = params.rentType.length && params.rentType[0] || ''
    params.communityName = defaultRoom?.communityName
    params.createBy = ownerInformation?.nickName;
    if (detailData && detailData?.sequenceNbr) {
      params.sequenceNbr = detailData?.sequenceNbr
      updateWechatRent(params).then(res => {
        if (res && res.code ===200) {
          Toast.success('修改更新成功')
          history.back()
        }
      })
    } else {
      addWechatRent(params).then(res => {
        if (res && res.code ===200) {
          Toast.success('新增成功')
          history.back()
        }
      })
    }
  };


  const onSuccess = (values: any) => {
    console.log(values)
    const obj = {
      roomType: '',
      facing: '',
      decoration: '',
      layout: '',
      floor: ''
    }
    for (let key in values) {
      if (values.hasOwnProperty(key)) {
        console.log(key, values[key]);
        obj[key as keyof typeof obj] = values[key] && values[key].length && values[key][0] || '';
      }
    }

    setTagData(obj)
    // form.setFieldsValue({obj})
    setSelectTagVisible(false)
  }

  return (
    <div className={styles.container}>
      <Form className={styles.form} form={form} ref={formRef} onFinish={onFinish}  footer={
        <div className={styles.buttonBox}>
          <Button round nativeType='submit' type='primary' block>
            提交
          </Button>
        </div>
      }>
        <Form.Item
          label={'发布类型'}
          name={'publishType'}
          isLink
          trigger={'onConfirm'}
          rules={[{ required: true, message: '请选择' }]}
          onClick={(_, action) => {
            console.log(action?.current, 'action');
            action?.current?.open();
          }}
        >
          <Picker popup columns={['求租', '求购']}>
            {(value) => value || '请选择发布类型'}
          </Picker>
        </Form.Item>
        <Form.Item
          isLink
          trigger={'onConfirm'}
          rules={[{ required: true, message: '请选择' }]}
          onClick={(_, action) => {
            action?.current?.open();
          }}
          name={'communityId'}
          label={'选择小区'}
        >
           <Picker title={'选择小区'} columns={communityPickerData} popup>
            {(value) =>
              value
                ? communityPickerData.find((item) => item?.value === value)
                    ?.text
                : '' || '选择'
            }
          </Picker>
        </Form.Item>
        <Form.Item rules={[{ required: true, message: '请填写' }]} label={'发布标题'} name={'title'}>
          <Input placeholder={'请输入标题'} />
        </Form.Item>
        <Form.Item rules={[{ required: true, message: '请选择' }]} label={'租售类别'} name={'rentType'}>
          <Selector
            options={[
              { label: '求租', value: '求租' },
              { label: '求购', value: '求购' },
            ]}
            
          />
        </Form.Item>
        <Form.Item label={'预算最低金额'} rules={[{ required: true, message: '请填写' }]} name={'minBudget'}>
          <Input type={'digit'} placeholder={'最低预算金额'} suffix={<div>元</div>}/>
        </Form.Item>
        <Form.Item label={'预算最高金额'} rules={[{ required: true, message: '请填写' }]} name={'maxBudget'}>
          <Input
            type={'digit'}
            placeholder={'最高预算金额'}
            suffix={<div>元</div>}
          />
        </Form.Item>
        <Form.Item label={'房屋面积'}  rules={[{ required: true, message: '请填写' }]} name={'area'}>
          <Input type={'number'} placeholder={'请输入房屋面积'} />
        </Form.Item>
        <Form.Item label={'房屋年限'} rules={[{ required: true, message: '请填写' }]} name={'duration'}>
          <Input type={'number'} placeholder={'请输入房屋年限'} />
        </Form.Item>
        {/* <Form.Item label={'联系人'} rules={[{ required: true, message: '请填写' }]}>
          <Input placeholder={'请输入联系人'} />
        </Form.Item> */}
        <Form.Item label={'联系电话'} rules={[{ required: true, message: '请填写' }, {
                  pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                  message: '请输入正确的手机号码',
                }]} name={'phone'}>
          <Input type={'tel'} placeholder={'请输入联系电话'} />
        </Form.Item>
        <Form.Item
          label={'选择标签'}
          isLink
          onClick={() => {
            setSelectTagVisible(true);
          }}
          name={'layout'}
        >
          <SelectHouseTag
            visible={selectTagVisible}
            defaultData={defaultTagData}
            onSuccess={onSuccess}
            onClose={() => setSelectTagVisible(false)}
          />
        </Form.Item>
        <Form.Item label={'房源描述'} name={'content'} rules={[{ required: true, message: '请填写' }]}>
          <Input.TextArea placeholder={'请输入房源描述'} />
        </Form.Item>
      </Form>
      {/* <StickyActiveButton activeText={'提交'} activeClick={onFinish} /> */}
    </div>
  );
};

export default PublishWantSale;
